const TOKEN_KEY = 'mall_access_token'
const USER_KEY = 'mall_user_info'
function isLoginEnabled() {
  return true
}

function getToken() {
  return typeof localStorage === 'undefined' ? '' : localStorage.getItem(TOKEN_KEY) || ''
}

function getUser() {
  if (typeof localStorage === 'undefined') return null
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  } catch (error) {
    localStorage.removeItem(USER_KEY)
    return null
  }
}

function saveLogin(data) {
  if (typeof localStorage === 'undefined') return
  localStorage.setItem(TOKEN_KEY, data.token || '')
  localStorage.setItem(USER_KEY, JSON.stringify(data.userInfo || {}))
}

function saveUser(user) {
  if (typeof localStorage !== 'undefined') localStorage.setItem(USER_KEY, JSON.stringify(user || {}))
}

function clearLogin() {
  if (typeof localStorage === 'undefined') return
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

function maskPhone(phone) {
  const value = String(phone || '')
  if (value.length < 7) return value
  return `${value.slice(0, 3)}****${value.slice(-4)}`
}

export default { isLoginEnabled, getToken, getUser, saveLogin, saveUser, clearLogin, maskPhone }
